<!--Very similar to BlogListing; a place to show all of the upcoming events
    and allow users to read more about them.
-->

<template>
  <main class="pad">
    <div v-if="!loading">
      <!--Parallax image with logo, title, and homepage link (if department EventListing)-->

      <PageHeader
        v-if="
          eventlisting.meta.parent.meta.type ==
          'departments.DepartmentLandingPage'
        "
        :title="eventlisting.title"
        :logo_url="
          eventlisting.logo
            ? eventlisting.logo.meta.download_url
            : eventlisting.get_department_logo_url
        "
        :image_url="
          eventlisting.image
            ? eventlisting.image.meta.download_url
            : eventlisting.get_department_image_url
        "
        :subtitle="eventlisting.subtitle ? eventlisting.subtitle : ''"
        :dept_link="'/departmentlandingpage/' + parentSlug"
      >
      </PageHeader>

      <PageHeader
        v-else
        :title="eventlisting.title"
        :logo_url="
          eventlisting.logo
            ? eventlisting.logo.meta.download_url
            : eventlisting.get_homepage_logo_url
        "
        :image_url="
          eventlisting.image
            ? eventlisting.image.meta.download_url
            : eventlisting.get_homepage_image_url
        "
        :subtitle="eventlisting.subtitle ? eventlisting.subtitle : ''"
      >
      </PageHeader>

      <!--Search field-->

      <mdb-container>
        <div class="input-group md-form form-sm form-1 pl-0">
          <div class="input-group-prepend">
            <span class="input-group-text lighten-3" id="basic-text1">
              <mdbIcon icon="search" />
            </span>
          </div>
          <input
            class="form-control my-0 py-1"
            type="text"
            placeholder="Search"
            v-model="searchQuery"
            aria-label="Search"
          />
        </div>

        <!--All posts returned by search (or displayed normally)
            Recieved info from EventPosts to render pagination
            properly.
        -->

        <mdb-container>
          <mdb-row>
            <mdb-col>
              <EventPosts
                v-if="!loading"
                :descendant_of="descendant_of"
                :search="safeReturnSearch"
                @setUpPagination="setUpPagination"
                :offset="offset"
                :type="page_type"
              ></EventPosts>
            </mdb-col>
          </mdb-row>

          <!--Pagination indicators (only show up if there is necessary pagination.-->

          <mdb-row v-if="num_pages > 1">
            <mdb-col>
              <mdb-pagination lg>
                <mdb-page-nav
                  prev
                  @click.native="setOffset(parseInt(current_pg) - 1)"
                  :disabled="current_pg == 1"
                ></mdb-page-nav>
                <mdb-page-item
                  v-for="(page, pg_num) in pg_ary"
                  :key="pg_num"
                  :active="current_pg == page"
                  @click.native="setOffset(page)"
                  >{{ page }}</mdb-page-item
                >
                <mdb-page-nav
                  next
                  @click.native="setOffset(parseInt(current_pg) + 1)"
                  :disabled="current_pg == num_pages"
                ></mdb-page-nav>
              </mdb-pagination>
            </mdb-col>
          </mdb-row>
        </mdb-container>
      </mdb-container>
    </div>
  </main>
</template>

<script>
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbIcon,
  mdbPagination,
  mdbPageNav,
  mdbPageItem,
} from "mdbvue";
import axios from "axios";
import api from "@/api";
import EventPosts from "@/views/events/EventPosts.vue";
import PageHeader from "@/views/PageHeader.vue";
import shared from "@/shared";
export default {
  name: "EventListing",
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbIcon,
    mdbPagination,
    mdbPageNav,
    mdbPageItem,
    EventPosts,
    PageHeader,
  },
  props: {
    slug: {
      type: [String],
    },
    type: {
      type: [String],
      default: "events.Event",
    },
  },
  data() {
    return {
      loading: true,
      descendant_of: false,
      eventlisting: false,
      searchQuery: "",
      parentSlug: "",
      offset: 0,
      current_pg: 1,
      pg_ary: [],
      num_pages: 0,
      page_type: "events.DepartmentEvent",
    };
  },
  computed: {
    axiosParams() {
      const params = new URLSearchParams();
      params.append("fields", "*");
      return params;
    },
    safeReturnSearch() {
      //TODO currently for some reason when cat/tags are filtered in rest api search opeartor doesnt work
      return this.searchQuery.trim();
    },
  },
  methods: {
    getData() {
      axios;
      api
        .get("pages/" + this.slug, {
          params: this.axiosParams,
        })
        .then((response) => {
          this.eventlisting = response.data;
          this.descendant_of = this.eventlisting.id;
          shared.getDepartmentSkinFromPage(this.eventlisting);
          this.parentSlug = shared.extractParentSlug(
            this.eventlisting.meta.parent.meta.html_url
          );
          if (
            this.eventlisting.meta.parent.meta.type !=
            "departments.DepartmentLandingPage"
          ) {
            this.page_type = "events.Event";
          }
        })
        .catch((e) => {
          this.errors.push(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setUpPagination(count) {
      /* If num posts > 10, paginate by 10 otherwise show all on one page */

      if (count == 0) {
        this.pg_ary = null;
        this.num_pages = 0;
        return;
      } else {
        this.num_pages = count / 10;
        this.num_pages = Math.ceil(this.num_pages);
      }
      var pg_num_ary = [];
      for (var i = 0; i < this.num_pages; i++) {
        pg_num_ary[i] = (i + 1).toString(); //TODo this is zero based; not sure yet if that is a problem...
      }
      this.pg_ary = pg_num_ary;
      //this.offset = 0;
    },
    clearSearch() {
      this.searchQuery = "";
    },
    setOffset(pg_num) {
      /* Offset ensures proper pagination */
      if (pg_num > 0) {
        if (pg_num == 1) {
          this.offset = 0;
        } else {
          this.offset = 10 * (pg_num - 1);
        }
        this.current_pg = pg_num;
      }
    },
  },
  watch: {
    slug: function () {
      this.clearSearch();
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
